import React from "react";
import styled from "styled-components";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardText
} from "reactstrap";
import ReactCarousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { isMobile } from 'react-device-detect'

const GuidesCarousel = styled(ReactCarousel)`
  padding-top: 1rem;
  padding-bottom: 1.5rem;

  .react-multi-carousel-track {
    align-items: stretch;
  }

  .react-multi-carousel-item {
    display: flex;
    height: auto;
  }
`;

const GuideSlide = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  padding: 0.5rem 0.75rem 1rem;
`;

const GuideCard = styled(Card)`
  width: 100%;
  height: 100%;
  background: transparent;
  overflow: visible;

  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;

  transition:
    transform 0.25s ease,
    box-shadow 0.25s ease;

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 0.85rem 1.5rem rgba(0, 0, 0, 0.2) !important;
  }
`;

const GuideImageArea = styled.div`
  padding: 1rem 1rem 0;
`;

const GuideImageWrapper = styled.div`
  position: relative;
  width: 72%;
  max-width: 190px;
  aspect-ratio: 370 / 500;
  margin: 0 auto;
  overflow: hidden;
  border-radius: 3rem;
  background-color: #f5f5f5;
`;

const GuideImage = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
`;

const GuideBadge = styled.span`
  position: absolute;
  left: 50%;
  bottom: 0.75rem;
  transform: translateX(-50%);
  white-space: nowrap;
`;

const GuideBody = styled(CardBody)`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

const GuideAccent = styled.div`
  width: 56px;
  height: 4px;
  margin: 0 auto 1rem;
  border-radius: 999px;
`;

const InfoLabel = styled.p`
  margin-bottom: 0.25rem;
  font-size: 0.72rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
`;

const RichText = styled.div`
  p {
    margin-bottom: 0;
  }
`;

const grid = {
  desktop: {
    breakpoint: {
      max: 8000,
      min: 992
    },
    items: 3,
    slidesToSlide: 1
  },
  tablet: {
    breakpoint: {
      max: 992,
      min: 576
    },
    items: 2,
    slidesToSlide: 1
  },
  mobile: {
    breakpoint: {
      max: 576,
      min: 0
    },
    items: 1,
    slidesToSlide: 1
  }
};

const Guides = ({ tour_guides = [] }) => {
  if (!tour_guides.length) {
    return null;
  }

  return (
    <>
      <Row>
        <Col>
          <h2 className="text-center mb-4">
            Meet Our Guides
          </h2>
        </Col>
      </Row>

      <Row>
        <Col xs="12">
          <GuidesCarousel
            responsive={grid}
            infinite={isMobile || tour_guides.length > 3}
            autoPlay={true}
            autoPlaySpeed={5000}
            pauseOnHover
            arrows
            swipeable
            draggable
            containerClass="guides-carousel"
          >
            {tour_guides.map((guide) => (
              <GuideSlide key={guide.id}>
                <GuideCard className="rounded-5">
                  {guide.cover_image && (
                    <GuideImageArea>
                      <GuideImageWrapper>
                        <GuideImage
                          src={guide.cover_image}
                          alt={guide.name || "Tour guide"}
                        />

                        {guide.name && (
                          <GuideBadge className="badge rounded-pill text-bg-primary px-3 py-2 text-white">
                            {guide.name}
                          </GuideBadge>
                        )}
                      </GuideImageWrapper>
                    </GuideImageArea>
                  )}

                  <GuideBody className="text-center px-4 py-4">
                    <GuideAccent className="bg-primary" />

                    {guide.role && (
                      <p className="text-primary fw-semibold small mb-3">
                        {guide.role}
                      </p>
                    )}

                    {guide.years_experience !== null &&
                      guide.years_experience !== undefined && (
                        <p className="fw-semibold small mb-3">
                          {guide.years_experience} years as a guide
                        </p>
                      )}

                    {guide.favourite_monument && (
                      <div className="mb-3">
                        <InfoLabel className="text-primary fw-bold">
                          Favourite monument
                        </InfoLabel>

                        <p className="mb-0 fw-semibold">
                          {guide.favourite_monument}
                        </p>
                      </div>
                    )}

                    {guide.special_tip && (
                      <div>
                        <InfoLabel className="text-primary fw-bold">
                          Guide’s special tip
                        </InfoLabel>

                        <CardText
                          tag="div"
                          className="text-muted small mb-0"
                        >
                          <RichText
                            dangerouslySetInnerHTML={{
                              __html: guide.special_tip
                            }}
                          />
                        </CardText>
                      </div>
                    )}
                  </GuideBody>
                </GuideCard>
              </GuideSlide>
            ))}
          </GuidesCarousel>
        </Col>
      </Row>
    </>
  );
};

export default Guides;